import { render } from "./SummaryCardDetails.vue?vue&type=template&id=b91b6f14"
import script from "./SummaryCardDetails.vue?vue&type=script&lang=js"
export * from "./SummaryCardDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__